import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ComentarioUICamViewModel } from './unidad-inspeccion-datosbasicos.types';

@Injectable()
export class ComentarioUiService {
    private comentarioUICamEndpoint = this.baseUrl + 'api/campanias/comentarioUnidadInspeccionCam/';
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getComentariosByIdUi(idUi: number): Observable<ComentarioUICamViewModel[]> {
        return this.http.get<ComentarioUICamViewModel[]>(this.comentarioUICamEndpoint + 'list/' + idUi);
    }

    saveComentario(comentario: ComentarioUICamViewModel): Observable<any> {
        if (comentario?.Id) {
            return this.editComentario(comentario);
        }

        return this.createComentario(comentario);
    }

    private editComentario(comentario: ComentarioUICamViewModel): Observable<any> {
        return this.http.put<ComentarioUICamViewModel>(this.comentarioUICamEndpoint, comentario);
    }

    private createComentario(comentario: ComentarioUICamViewModel): Observable<any> {
        return this.http.post<ComentarioUICamViewModel>(this.comentarioUICamEndpoint, comentario);
    }

    deleteComentario(id: number): Observable<any> {
        return this.http.delete<any>(this.comentarioUICamEndpoint + id);
    }
}
